export default __webpack_public_path__ + "static/media/ic_elements.63f118ed.svg";